import { ReactNode } from "react";
import { FormSpy } from "react-final-form";

import { useClaimAdjustmentContext } from "@modules/acc/screens/claim-adjustment/context/ClaimAdjustmentContext.ts";
import { ClaimAdjustmentFormValues } from "@shared-types/acc/claim-adjustment-form-values.type.ts";
import { CardFormLayout } from "@ui-components/card-form-layout/CardFormLayout.tsx";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

import { AddDiagnosisFormSection } from "./AddDiagnosisFormSection.tsx";
import { ChangeDiagnosisFormSection } from "./ChangeDiagnosisFormSection.tsx";
import { ChangeSideFormSection } from "./ChangeSideFormSection.tsx";
import { ClaimAdjustmentOverviewSection } from "./claim-adjustment-overview-section/ClaimAdjustmentOverviewSection.tsx";
import { CurrentStatusAndPrognosisFormSection } from "./CurrentStatusAndPrognosisFormSection.tsx";
import { DocumentationFormSection } from "./DocumentationFormSection.tsx";
import { DocumentUploadStatusModal } from "./DocumentUploadStatusModal.tsx";
import { PatientDetailsFormSection } from "./PatientDetailsFormSection.tsx";
import { PatientProviderDeclarationFormSection } from "./PatientProviderDeclarationFormSection.tsx";
import { ProviderDetailsFormSection } from "./ProviderDetailsFormSection.tsx";
import { TreatmentDetailsFormSection } from "./TreatmentDetailsFormSection.tsx";
import { getClaimAdjustmentMenuItems } from "./utils.ts";

interface ClaimAdjustmentFormEditProps {
  header: ReactNode;
}

export const ClaimAdjustmentFormEdit: React.FC<
  ClaimAdjustmentFormEditProps
> = ({ header }) => {
  const context = useClaimAdjustmentContext();
  const {
    claimAdjustment,
    showCurrentStatusAndPrognosisSection,
    isNonStandardCodeSelected
  } = context;

  const patientLabel = usePatientLabel(true);

  const showCurrentStatusAndPrognosis = () => {
    return showCurrentStatusAndPrognosisSection(isNonStandardCodeSelected());
  };

  return (
    <CardFormLayout
      sideRailMenuItems={getClaimAdjustmentMenuItems(
        showCurrentStatusAndPrognosis(),
        patientLabel,
        claimAdjustment
      )}
      header={header}
    >
      <DocumentUploadStatusModal />
      <FormSpy<ClaimAdjustmentFormValues>
        subscription={{ dirty: true, values: true }}
        onChange={({ values }) => {
          context.claimAdjustmentFormValues = values;
        }}
      />
      <ClaimAdjustmentOverviewSection />
      <PatientDetailsFormSection />
      <ProviderDetailsFormSection />
      <TreatmentDetailsFormSection />
      <AddDiagnosisFormSection />
      <ChangeSideFormSection />
      <ChangeDiagnosisFormSection />
      <CurrentStatusAndPrognosisFormSection />
      <DocumentationFormSection />
      <PatientProviderDeclarationFormSection />
    </CardFormLayout>
  );
};
